<template>
  <div v-if="is_data_fetched">
    <div>
      <p class="bold">שם המתכון</p>
      <input v-model="form.data.vetting_recipe.fields.recipe_name.value" class="outlined">
    </div>
    <div style="margin-top: 20px;">
      <p class="bold">מתכון לנקבה</p>
      <textarea v-model="form.data.vetting_recipe.fields.recipe_female.value" rows="15" class="full_width"></textarea>
    </div>
    <div style="margin-top: 20px;">
      <p class="bold">מתכון לזכר</p>
      <textarea v-model="form.data.vetting_recipe.fields.recipe_male.value" rows="15" class="full_width"></textarea>
    </div>
    <div dir="ltr" class="text_align_left">
      <p>Attach {EDUCATIONS} where you want to add educations</p>
      <p>Attach {HISTORY_COMPANIES} where you want to add history companies</p>
      <p>Attach {CERTIFICATION_DATE} where you want to add certification date</p>
    </div>
    <div class="modal_footer">
      <a @click="submit" class="button is-info" :class="{ 'is-loading': is_loading }">Submit</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'vetting-recipe-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      form: undefined,
      is_data_fetched: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        this.is_data_fetched = true
        return
      }
      const response = await this.$network_utils.getVettingRecipe({ id: this.payload.data.id })
      this.setForm(response)
      this.is_data_fetched = true
    },
    setForm (form_data) {
      this.form = new this.$form({
        vetting_recipe: {
          fields: {
            recipe_name: {
              value: form_data.recipe_name,
              has_error: false,
              validations: []
            },
            recipe_male: {
              value: form_data.recipe_male,
              has_error: false,
              validations: []
            },
            recipe_female: {
              value: form_data.recipe_female,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/vetting_recipes/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
